import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TicketsComponent } from '../../tickets/tickets.component';
import { DetailComponent } from '../../tickets/detail/detail.component';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgStreamingModule } from '@videogular/ngx-videogular/streaming';
import { NumberracePipe } from '../../pipe/numberrace.pipe';
import { AlertMessageComponent } from '../../alert-message/alert-message.component';
import { DataDialogConfirmComponent } from '../../alert-message/data-dialog-confirm/data-dialog-confirm.component';
import {PageErrorComponent} from '../../content/page-error/page-error.component';
import {ContentModule} from '../../content/content.module';
import {HexToDecimalPipe} from '../../pipe/hex-to-decimal.pipe';
import {NameDottenPipe} from '../../pipe/name-dotten.pipe';
import {InfoAggBetPipe} from '../../pipe/info-agg-bet.pipe';
import {DistanceResultPipe} from '../../pipe/distance-result.pipe';

@NgModule({
    declarations: [
        TicketsComponent,
        DetailComponent,
        NumberracePipe,
        HexToDecimalPipe,
        NameDottenPipe,
        AlertMessageComponent,
        DataDialogConfirmComponent,
        PageErrorComponent,
        InfoAggBetPipe,
        DistanceResultPipe
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgStreamingModule,
    ],
    exports: [
        TicketsComponent,
        DetailComponent,
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgStreamingModule,
        AlertMessageComponent,
        DataDialogConfirmComponent,
        PageErrorComponent,
        HexToDecimalPipe,
        NameDottenPipe,
        InfoAggBetPipe,
        DistanceResultPipe
    ]
})
export class SharedModule {}
